var _mask, _path, _path2, _circle, _path3, _ellipse, _path4, _circle2, _path5, _ellipse2, _path6, _circle3, _path7, _ellipse3, _path8, _circle4, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 193,
    viewBox: "0 0 193 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_691_160",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 193,
    height: 193,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 193,
    height: 193
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 96.5C190 148.139 148.139 190 96.5 190C44.8614 190 3 148.139 3 96.5C3 44.8614 44.8614 3 96.5 3C148.139 3 190 44.8614 190 96.5ZM7.28014 96.5C7.28014 145.775 47.2252 185.72 96.5 185.72C145.775 185.72 185.72 145.775 185.72 96.5C185.72 47.2252 145.775 7.28014 96.5 7.28014C47.2252 7.28014 7.28014 47.2252 7.28014 96.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 96.5C190 148.139 148.139 190 96.5 190C44.8614 190 3 148.139 3 96.5C3 44.8614 44.8614 3 96.5 3C148.139 3 190 44.8614 190 96.5ZM7.28014 96.5C7.28014 145.775 47.2252 185.72 96.5 185.72C145.775 185.72 185.72 145.775 185.72 96.5C185.72 47.2252 145.775 7.28014 96.5 7.28014C47.2252 7.28014 7.28014 47.2252 7.28014 96.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190 96.5C190 148.139 148.139 190 96.5 190C44.8614 190 3 148.139 3 96.5C3 44.8614 44.8614 3 96.5 3C148.139 3 190 44.8614 190 96.5ZM7.28014 96.5C7.28014 145.775 47.2252 185.72 96.5 185.72C145.775 185.72 185.72 145.775 185.72 96.5C185.72 47.2252 145.775 7.28014 96.5 7.28014C47.2252 7.28014 7.28014 47.2252 7.28014 96.5Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-1-outside-1_691_160)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 52,
    r: 15,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5395 74.6086C70.0008 79.0917 63.4474 96.3716 62 107H128C128 98.4973 122.355 79.1637 110.632 74.6086C99.7763 69.5473 93.2632 70.0536 81.5395 74.6086Z",
    fill: "white",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 66,
    rx: 16.8182,
    ry: 15,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.908 88.6086C111.971 93.0917 104.623 110.372 103 121H177C177 112.497 170.671 93.1637 157.526 88.6086C145.355 83.5473 138.053 84.0536 124.908 88.6086Z",
    fill: "black",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 66,
    r: 15,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.539 88.6086C115.001 93.0917 108.447 110.372 107 121H173C173 112.497 167.355 93.1637 155.632 88.6086C144.776 83.5473 138.263 84.0536 126.539 88.6086Z",
    fill: "white",
    stroke: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.9997,
    cy: 65.8571,
    rx: 17.7273,
    ry: 15.8571,
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0921 89.7577C24.4554 94.497 16.7105 112.764 15 124H93C93 115.011 86.3289 94.5731 72.4737 89.7577C59.6447 84.4072 51.9474 84.9424 38.0921 89.7577Z",
    fill: "black",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 68,
    r: 15,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5395 90.6086C29.0008 95.0917 22.4474 112.372 21 123H87C87 114.497 81.3553 95.1637 69.6316 90.6086C58.7763 85.5473 52.2632 86.0536 40.5395 90.6086Z",
    fill: "white",
    stroke: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97,
    cy: 100,
    rx: 17,
    ry: 16,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0921 121.758C67.4554 126.497 59.7105 144.764 58 156H136C136 147.011 129.329 126.573 115.474 121.758C102.645 116.407 94.9474 116.942 81.0921 121.758Z",
    fill: "black",
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 100,
    r: 15,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5395 122.609C72.0008 127.092 65.4474 144.372 64 155H130C130 146.497 124.355 127.164 112.632 122.609C101.776 117.547 95.2632 118.054 83.5395 122.609Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/Team.8e984c492a60aed3bfab40bac6200e71.svg";
export { ForwardRef as ReactComponent };